import React from "react";
import { Link } from "react-router-dom";
//importing assets
import Error404 from "../Assets/illustration/error404.svg";
import HeadTitle from "../components/global/HeadTitle";

const NotFound = () => {
  return (
    <div className="notfound">
      <img src={Error404} alt="not found" className="notfound__img" />

      <HeadTitle title="Page Not Found" />
      <Link to="/">
        <button className="btn btn__primary notfound__btn">
          Go To Home Page
        </button>
      </Link>
    </div>
  );
};
export default NotFound;
